import React, { useState } from "react";
import firebase from '../util/firebase.js';
import FormAlert from "./FormAlert";
import FormField from "./FormField";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { useAuth } from "../util/auth.js";
import { useForm } from "react-hook-form";

function AddCoffeeNew(props) {
  const auth = useAuth();
  const [pending, setPending] = useState(false);
  const [formAlert, setFormAlert] = useState(null);
  const { handleSubmit, register, errors, reset } = useForm();

   const onSubmit = (data) => {
       const { 
        coffeeName, 
        coffeeProductUrl, 
        coffeeCountry, 
        coffeeRegion,
        growingRegion, 
        coffeeCompany, 
        coffeeCompanyUrl, 
        tastingNotes, 
        coffeeFlavorFruity, 
        coffeeFlavorCitrus, 
        coffeeFlavorFloral, 
        coffeeFlavorSweet, 
        coffeeFlavorChocolateNutty, 
        coffeeFlavorSpicy, 
        coffeeFlavorRoasted,
        coffeeCultivar, 
        coffeeTypeBlend,
        coffeeTypeSingleOrigin,
        coffeeTypeEspresso,
        coffeeTypeDecaffeinated,
        coffeeTypeOther,
        coffeeProcess, 
        coffeeFarm,
        coffeeProducer, 
        coffeeElevation, 
        coffeeHarvest, 
        coffeeAvailability,
        coffeeOffering, 
        coffeePrice,  
        coffeeBagSize,
        roasterLocation, 
        coffeeImage } = data;
    // Show pending indicator
    setPending(true);    

    const newCoffee = { 
      coffeeName,
      coffeeProductUrl,
      coffeeCountry,
      coffeeRegion,
      growingRegion,
      coffeeCompany,
      coffeeCompanyUrl,
      tastingNotes,
      coffeeFlavor: [
        coffeeFlavorFruity, 
        coffeeFlavorCitrus, 
        coffeeFlavorFloral, 
        coffeeFlavorSweet, 
        coffeeFlavorChocolateNutty, 
        coffeeFlavorSpicy, 
        coffeeFlavorRoasted].filter(Boolean),
      coffeeFlavorFruity,
      coffeeFlavorCitrus,
      coffeeFlavorFloral, 
      coffeeFlavorSweet,
      coffeeFlavorChocolateNutty,
      coffeeFlavorSpicy,
      coffeeFlavorRoasted,     
      coffeeCultivar,
      coffeeType: [
        coffeeTypeBlend, 
        coffeeTypeSingleOrigin, 
        coffeeTypeEspresso, 
        coffeeTypeDecaffeinated, 
        coffeeTypeOther].filter(Boolean),
      coffeeTypeBlend,
      coffeeTypeSingleOrigin,
      coffeeTypeEspresso,
      coffeeTypeDecaffeinated,
      coffeeTypeOther,
      coffeeProcess,
      coffeeFarm,
      coffeeProducer,
      coffeeElevation: parseFloat(coffeeElevation),
      coffeeHarvest,
      coffeeAvailability,
      coffeeAvailabilityVote: 0,
      coffeeOffering,
      coffeePrice: parseFloat(coffeePrice),
      coffeeBagSize: parseFloat(coffeeBagSize),
      coffeePricePer340g: parseFloat((340/coffeeBagSize*coffeePrice).toFixed(2)),
      coffeePricePer20g: parseFloat((20/coffeeBagSize*coffeePrice).toFixed(2)),
      roasterLocation,
      coffeeReviewAvg: 0,
      coffeeReviewsNumTotal: 0,
      coffeeReviewsNumTotalAdj: 0,
      coffeeRatingTotalAdj: 0,
      createdTime: firebase.firestore.FieldValue.serverTimestamp(),
      uid: auth.user.id,
      coffeeId: "",
      coffeeImgUrl: "",
    };

    const createCoffee = async (data) => {
      const { id } = await firebase.firestore().collection('coffee').add(data);
      //After document created, document id is available
      const imgRef = firebase.storage().ref().child(`Coffee Product Images/${id}`);
      await imgRef.put(coffeeImage[0]);
      const imgUrl = await imgRef.getDownloadURL();
      //Update database with document id and coffee image URL
      firebase.firestore().collection('coffee').doc(id).update({coffeeId: id, coffeeImgUrl: imgUrl});
    }

    // const uploadCoffeePhoto = async () => {
    //   const file = coffeeImage[0];
    //   const storageRef = firebase.storage().ref();
    //   const fileRef = storageRef.child(`Coffee Product Images/${file.name}`);
    //   await fileRef.put(file);
    //   const imgUrl = await fileRef.getDownloadURL();
    //   console.log(imgUrl)


    //   // const imgRef = firebase.storage().ref().child(`Coffee Product Images/${coffeeCompany + " " + coffeeName}`);
    //   // await imgRef.put(coffeeImage[0]);
    //   // const imgUrl = await imgRef.getDownloadURL();
    //   // console.log(imgUrl);
    //   // console.log(coffeeIdState)
    // };

    return createCoffee(newCoffee)
      .then(() => {
        // Clear form
        reset();
        // Show success alert message
        setFormAlert({
          type: "success",
          message: "Your coffee has been added!",
        });
      })
      .catch((error) => {
        // Show error alert message
        setFormAlert({
          type: "error",
          message: error.message,
        });
      })
      .finally(() => {
        // Hide pending indicator
        setPending(false);
      });
  };

  return (
    <>
      {formAlert && (
        <FormAlert 
        type={formAlert.type} 
        message={formAlert.message} 
        className="mx-auto mb-4 text-center" 
        style={{ maxWidth: "450px" }} />
      )}

      <Form onSubmit={handleSubmit(onSubmit)}>
      {props.showNameField && (
        <Form.Group controlId="formCoffeeName">
          <FormField
            name="coffeeName"
            type="text"
            label="Coffee Name*"
            placeholder="Coffee Name"
            error={errors.coffeeName}
            inputRef={register({
              required: "Please enter a Coffee Name that is less than 64 characters",
              maxLength: 64
            })}
          />
        </Form.Group>
      )}

      <Form.Group controlId="formCoffeeCompany">
          <FormField
            name="coffeeCompany"
            type="text"
            label="Coffee Company*"
            placeholder='Coffee Company, please leave off suffixes such as "coffee roaster" or "coffee company"'
            error={errors.coffeeCompany}
            inputRef={register({
              required: "Please enter a Coffee Company Name",
              maxLength : {
                value: 32,
                message: 'Please try to keep less than 32 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeProductUrl">
          <FormField
            name="coffeeProductUrl"
            type="url"
            label="Coffee Product Page Url"
            placeholder="Copy & Paste the coffee product page URL here"
            error={errors.coffeeProductUrl}
            inputRef={register}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeCompanyUrl">
          <FormField
            name="coffeeCompanyUrl"
            type="url"
            label="Coffee Company Homepage"
            placeholder="Copy & paste the coffee company's homepage URL here"
            error={errors.coffeeCompanyUrl}
            inputRef={register}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeCountry">
          <FormField
            name="coffeeCountry"
            type="text"
            label="Coffee Origin Country"
            placeholder="Coffee Origin Country"
            error={errors.coffeeCountry}
            inputRef={register({
              maxLength : {
                value: 32,
                message: 'Please try to keep less than 32 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formGrowingRegion">
          <Form.Label>Growing Region</Form.Label>
          <Form.Control
            as="select" 
            name="growingRegion"
            error={errors.growingRegion}
            ref={register}
            > 
            <option value="">Select growing region if has a single origin</option>
            <option label="Africa or Arabia">africaArabia</option>
            <option label="Asia or Pacific">asiaPacific</option>
            <option label="Caribbean">caribbean</option>            
            <option label="Central America">centralAmerica</option>            
            <option label="Hawaii">hawaii</option>
            <option label="South America">southAmerica</option>
            <option label="Other">other</option>
          </Form.Control>
          </Form.Group>

        <Form.Group controlId="formCoffeeRegion">
          <FormField
            name="coffeeRegion"
            type="text"
            label="Coffee Country Origin Region"
            placeholder="Coffee Origin Region in Country"
            error={errors.coffeeRegion}
            inputRef={register({
              maxLength : {
                value: 32,
                message: 'Please try to keep less than 32 characters' 
              }
            })}
          />
        </Form.Group>        

        <Form.Group controlId="formTastingNotes">
          <FormField
            name="tastingNotes"
            type="text"
            label="Roaster Tasting Notes"
            placeholder="Tasting Notes"
            error={errors.tastingNotes}
            inputRef={register({
              maxLength : {
                value: 64,
                message: 'Please try to keep less than 64 characters' 
              }
            })}
          />
        </Form.Group>

        {/* <Form.Group controlId="formCoffeeFlavor">
          <Form.Label>Coffee Flavors (select multiple)</Form.Label>
          <Form.Control
            as="select" 
            multiple
            name="coffeeFlavor"
            error={errors.coffeeFlavor}
            ref={register}
            > 
            <option label="Fruity - blueberry, cherry, grape, apple, peach" >Fruity</option>
            <option label="Citrus - orange, lemon, grapefruit, lime">Citrus</option>
            <option label="Floral - jasmine, rose, chamomile">Floral</option>
            <option label="Sweet - honey, vanilla, brown sugar">Sweet</option>
            <option label="Chocolate or Nutty - chocolate, almond, hazelnut">Chocolate/Nutty</option>
            <option label="Spicy - clove, cinnamon, anise">Spicy</option>
            <option label="Smoky - tobacco, roasted">Roasted</option>
          </Form.Control>
          </Form.Group> */}

        <Form.Group controlId="formCoffeeFlavor">
        <Form.Check ref={register} type="checkbox" value="Fruity" label="Fruity - blueberry, cherry, grape, apple, peach" name="coffeeFlavorFruity" error={errors.coffeeFlavorFruity} />
        <Form.Check ref={register} type="checkbox" value="Citrus" label="Citrus - orange, lemon, grapefruit, lime" name="coffeeFlavorCitrus" error={errors.coffeeFlavorCitrus}  />
        <Form.Check ref={register} type="checkbox" value="Floral" label="Floral - jasmine, rose, chamomile" name="coffeeFlavorFloral" error={errors.coffeeFlavorFloral}  />
        <Form.Check ref={register} type="checkbox" value="Sweet" label="Sweet - honey, vanilla, brown sugar" name="coffeeFlavorSweet" error={errors.coffeeFlavorSweet}  />
        <Form.Check ref={register} type="checkbox" value="Chocolate/Nutty" label="Chocolate or Nutty - chocolate, almond, hazelnut" name="coffeeFlavorChocolateNutty" error={errors.coffeeFlavorChocolateNutty}  />
        <Form.Check ref={register} type="checkbox" value="Spicy" label="Spicy - clove, cinnamon, anise" name="coffeeFlavorSpicy" error={errors.coffeeFlavorSpicy}  />
        <Form.Check ref={register} type="checkbox" value="Smoky" label="Smoky - tobacco, roasted" name="coffeeFlavorRoasted" error={errors.coffeeFlavorRoasted}  />
        </Form.Group>

        <Form.Group controlId="formCultivar">
          <FormField
            name="coffeeCultivar"
            type="text"
            label="Coffee Cultivar"
            placeholder='Coffee Cultivar'
            error={errors.coffeeCultivar}
            inputRef={register({
              maxLength : {
                value: 32,
                message: 'Please try to keep less than 32 characters' 
              }
            })}
          />
        </Form.Group>

          {/* <Form.Group controlId="formCoffeeType">
          <Form.Label>Coffee Type (select multiple)</Form.Label>
          <Form.Control
            as="select" 
            multiple
            name="coffeeType"
            error={errors.coffeeType}
            ref={register}
            > 
            <option>Blend</option>
            <option>Single Origin</option>
            <option>Espresso</option>
            <option>Decaffeinated</option>
            <option>Other</option>
          </Form.Control>
          </Form.Group> */}

        <Form.Group controlId="formCoffeeType">
        <Form.Label>Coffee Type (select multiple)</Form.Label>
        <Form.Check ref={register} type="checkbox" label="Blend" value="Blend" name="coffeeTypeBlend" error={errors.coffeeTypeBlend} />
        <Form.Check ref={register} type="checkbox" label="Single Origin" value="Single Origin" name="coffeeTypeSingleOrigin" error={errors.coffeeTypeSingleOrigin}  />
        <Form.Check ref={register} type="checkbox" label="Espresso" value="Espresso" name="coffeeTypeEspresso" error={errors.coffeeTypeEspresso}  />
        <Form.Check ref={register} type="checkbox" label="Decaffeinated" value="Decaffeinated" name="coffeeTypeDecaffeinated" error={errors.coffeeTypeDecaffeinated}  />
        <Form.Check ref={register} type="checkbox" label="Other" value="Other" name="coffeeTypeOther" error={errors.coffeeTypeOther}  />
        </Form.Group>

          <Form.Group controlId="formCoffeeProcess">
          <FormField
            name="coffeeProcess"
            type="text"
            label="Coffee Process Method"
            placeholder="Washed, Natural, Honey, Anaerobic..."
            error={errors.coffeeProcess}
            inputRef={register({
              maxLength : {
                value: 64,
                message: 'Please try to keep less than 64 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeFarm">
          <FormField
            name="coffeeFarm"
            type="text"
            label="Farm"
            placeholder="Name of the farm where the coffee was grown"
            error={errors.coffeeFarm}
            inputRef={register({
              maxLength : {
                value: 64,
                message: 'Please try to keep less than 64 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeProducer">
          <FormField
            name="coffeeProducer"
            type="text"
            label="Producer"
            placeholder="Name of the coffee producer"
            error={errors.coffeeFarm}
            inputRef={register({
              maxLength : {
                value: 64,
                message: 'Please try to keep less than 64 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeElevation">
          <FormField
            name="coffeeElevation"
            type="number"
            label="Coffee Elevation (meters)"
            placeholder="Elevation in meters that coffee was grown at"
            error={errors.coffeeElevation}
            inputRef={register({
              maxLength : {
                value: 16,
                message: 'Please try to keep less than 16 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeHarvest">
          <FormField
            name="coffeeHarvest"
            type="text"
            label="Coffee Harvest"
            placeholder="Month(s)/Year e.g. October - November 2019"
            error={errors.coffeeHarvest}
            inputRef={register({
              maxLength : {
                value: 32,
                message: 'Please try to keep less than 32 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeAvailability">
          <Form.Label>Coffee Availability</Form.Label>
          <Form.Control
            as="select" 
            name="coffeeAvailability"
            error={errors.coffeeAvailability}
            ref={register}
            >             
            <option label="Available">Likely Available</option>
            <option label="Sold Out">Possibly Sold Out</option>
          </Form.Control>
          </Form.Group>

          <Form.Group controlId="formCoffeeOfferingType">
          <Form.Label>Coffee Offering Type</Form.Label>
          <Form.Control
            as="select" 
            name="coffeeOffering"
            error={errors.coffeeOffering}
            ref={register}
            > 
            <option value="">Select if sold year round of a limited run</option>
            <option label="Limited or Seasonal">Limited</option>
            <option label="Year-Round">Year-Round</option>
          </Form.Control>
          </Form.Group>

        <Form.Group controlId="formCoffeePrice">
          <FormField
            name="coffeePrice"
            type="number"
            step="0.01"
            label="Coffee Price"
            placeholder="Please enter the USD value of the coffee"
            error={errors.coffeePrice}
            inputRef={register({
              maxLength : {
                value: 9,
                message: 'Please try to keep less than 9 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formCoffeeBagSize">
          <FormField
            name="coffeeBagSize"
            type="number"
            label="Coffee Bag Size (grams)"
            placeholder="Please enter the coffee bag size in grams"
            error={errors.coffeeBagSize}
            inputRef={register({
              maxLength : {
                value: 9,
                message: 'Please try to keep less than 9 characters' 
              }
            })}
          />
        </Form.Group>

        <Form.Group controlId="formRoasterLocation">
          <FormField
            name="roasterLocation"
            type="text"
            label="Roaster Location"
            placeholder="Please enter the location of the roaster such as Portland, Oregon or Seoul, South Korea"
            error={errors.roasterLocation}
            inputRef={register({
              maxLength : {
                value: 64,
                message: 'Please try to keep less than 64 characters' 
              }
            })}
          />
        </Form.Group>

          <Form.Group controlId="formCoffeeImage">
          <FormField
            name="coffeeImage"
            label="Upload photo of coffee bag"
            type="file"
            error={errors.coffeeImage}
            inputRef={register}
          />
        </Form.Group>

        <Button
          variant={props.buttonColor}
          size={props.inputSize}
          type="submit"
          disabled={pending}
        >
          <span>{props.buttonText}</span>

          {pending && (
            <Spinner
              animation="border"
              size="sm"
              role="status"
              aria-hidden={true}
              className="ml-2"
            >
              <span className="sr-only">Adding...</span>
            </Spinner>
          )}
        </Button>
      </Form>
    </>
  );
}

export default AddCoffeeNew;